import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UserFilters } from '../../../commons/models/user.model';

@Component({
    selector: 'app-users-filters',
    templateUrl: './users-filters.component.html',
    styleUrls: ['./users-filters.component.scss']
})
export class UsersFiltersComponent{
    @Output()
    onFilter: EventEmitter<UserFilters> = new EventEmitter();
    
    private _defaultFilters: UserFilters;
    filtersForm: FormGroup;

    constructor(private fb: FormBuilder) {
    this._createForm();
    }

    private _createForm() {
    let group = {
        search: "",
    }

    this.filtersForm = this.fb.group(group);
    }

    applyFilters() {
    this.onFilter.emit(this._getPayment());
    }

    private _getPayment(): UserFilters {
    let filters: UserFilters = {}
    if (this.filtersForm) {
        const values = this.filtersForm.value;
        filters.search = values.search;
    }
    return filters;
    }

    resetFilters() {
    this.filtersForm.reset();
    this.filtersForm.patchValue({
        search: "",
    });
    this._setDefaultValues();
    this.applyFilters();
    }

    get defaultFilters(): UserFilters {
    return this._defaultFilters;
    }

    @Input()
    set defaultFilters(defaultFilters: UserFilters) {
    this._defaultFilters = defaultFilters;
    this._setDefaultValues();
    }

    private _setDefaultValues() {
        if (this.defaultFilters) {
            if (this.filtersForm) {
            this.filtersForm.patchValue({
                search: this.defaultFilters.search,
            })
            }
        }
    }
    
}